console.log('As dusk falls we walk in the meadow. https://lttstore.com/meadow')

  let pagesLoaded = 1;


function getDiscountCode() {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; discount_code=`);
  
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(';').shift());
  }
  return null;
}

// disable sea accessibility overriding the most useful shortcut in the world
document.addEventListener('keydown', function(event) {
  if ((event.ctrlKey || event.metaKey) && event.key === 'x') {
    event.stopImmediatePropagation(); 
  }
}, true);

const removeHiddenAnnouncements = () => {
  let currentDismissedAnnouncements = JSON.parse(localStorage.getItem('dismissAnnouncement'));

  if (currentDismissedAnnouncements) {
    currentDismissedAnnouncements.forEach(block_id => {
      let announcementBlock = document.getElementById(block_id);
      if(announcementBlock) announcementBlock.remove();
    });
  }
  const announcementPaused = document.querySelector('.pause-announcement-reveal');
  if(announcementPaused) announcementPaused.classList.remove('pause-announcement-reveal');

  // swap to new announcement if available
  const proceedButton = document.querySelector('.announcement-bar__wrapper button[is="next-button"]')
  if(proceedButton) proceedButton.click();
  const previousButton = document.querySelector('.announcement-bar__wrapper button[is="prev-button"]')
  if(previousButton) previousButton.click();
}
removeHiddenAnnouncements();

const dismissAnnouncement = (activeAnnouncementIds) => {
  let currentDismissedAnnouncements = JSON.parse(localStorage.getItem('dismissAnnouncement'));
  if(currentDismissedAnnouncements == null) currentDismissedAnnouncements = [];

  let activeAnnouncements = activeAnnouncementIds.split(',');
  activeAnnouncements.forEach(block_id => {
    if(currentDismissedAnnouncements.includes(block_id) == false) currentDismissedAnnouncements.push(block_id);
  });
  localStorage.setItem('dismissAnnouncement', JSON.stringify(currentDismissedAnnouncements));


  removeHiddenAnnouncements();
}


// HANDLE REGION REDIRECTS
const regionalParams = new URLSearchParams(window.location.search);
const regionRedirect = regionalParams.get('regionRedirect');

if(regionRedirect) {
  const newUrl = new URL(window.location);
  newUrl.searchParams.delete('regionRedirect');
  window.history.replaceState({}, '', newUrl);
  localStorage.setItem('customerRegion', regionRedirect);
}

let urlPath = window.location.pathname+window.location.search;
let cleanPath = urlPath.replace("&country=US&currency=USD", "");
const isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
const redirectRegion = (region) => {
  if(!Shopify.designMode && !isLocalPreview && !urlPath.includes('/pages/favorites?id=')) {
    if(region == 'us') {
      const resultUrl = new URL(`https://www.lttstore.com${cleanPath}`);
      resultUrl.searchParams.append('regionRedirect', region);
      window.location.replace(resultUrl.href);
    } else if(region == 'global') {
      const resultUrl = new URL(`https://global.lttstore.com${cleanPath}`);
      resultUrl.searchParams.append('regionRedirect', region);
      window.location.replace(resultUrl.href);
    }
  }
}

const checkRegion = (region) => {
  localStorage.setItem('customerRegion', region)
  if(region == 'us' && window.location.href.includes('global')) {
    redirectRegion(region);
  } else if(region == 'global' && window.location.href.includes('lttstore')) {
    redirectRegion(region);
  }
}

let userCountry = null;
(async () => {
  
  try {
    const res = await fetch(`${window?.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true`);
    const json = await res.json();
    const country = json?.detected_values?.country?.handle;
    if (country) userCountry = country;
  } catch (e) {
    console.error('Geolocation fetch failed:', e);
  }

  if (userCountry) {} else {
    const ipRequest = await fetch("https://api.ipinfo.io/lite/me?token=e5bf82d18ee1e9");
    ipResponse = await ipRequest.json();
    userCountry = ipResponse.country_code;
  };

  userCountry = userCountry.toLowerCase();



const storedCountry = localStorage.getItem('customerRegion');
if(storedCountry == 'international') {
  localStorage.setItem('customerRegion', 'global')
} else if (storedCountry == 'US') {
  localStorage.setItem('customerRegion', 'us');
}
if(storedCountry){
  if(storedCountry == 'us' && window.location.href.includes('global.lttstore')) {
    redirectRegion(storedCountry);
  } else if(storedCountry == 'global' && !window.location.href.includes('global.lttstore')) {
    redirectRegion(storedCountry);
  } 
} else if(userCountry == 'us' && window.location.href.includes('global.lttstore')) {
    RegionPopover.showPopover();
} else if(userCountry !== 'us' && !window.location.href.includes('global.lttstore')) {  
    RegionPopover.showPopover();
}
  
})();


// collection reload
const targetNode = document.querySelector('.shopify-section--main-collection');
const config = { childList: true };
const callback = function(mutationsList, observer) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      collectionCount.style.setProperty('--product-count', `'${document.querySelectorAll('.product-card').length}'`);
      var endlessScroll = new Ajaxinate();
      registerRestoreAjaxinate();
      break; 
    }
  }
};

const observer = new MutationObserver(callback);
if (targetNode) {
  observer.observe(targetNode, config);
}

// HOMEPAGE HERO BANNER CONVERSION TRACKING (Session-based Last-Click)
(() => {
  const STORAGE_KEY = 'ltt_hp_banner';

  const syncBannerToCart = (payload, force = false) => {
    if (!payload || (!force && payload.synced)) return;

    const attributes = {
      hp_banner: payload.name,
      hp_banner_slot: String(payload.slot),
      hp_banner_target: payload.target,
      hp_banner_clicked_at: payload.clickedAt
    };

    fetch(`${window?.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((cart) => {
        payload.synced = true;
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (e) {}
        console.info('[LTT Banner Tracking] Synced homepage banner attribution to cart:', attributes, cart?.attributes);
      })
      .catch((err) => {
        console.warn('[LTT Banner Tracking] Deferred cart attribute sync until next page load:', err);
      });
  };

  // 1. Capture clicks on homepage hero slideshow banners (Last-Click in session wins)
  document.addEventListener(
    'click',
    (event) => {
      const slide = event.target.closest('.slideshow__slide[data-hp-banner-name]');
      if (!slide) return;

      const linkEl = slide.matches('a[href]') ? slide : event.target.closest('a[href]');
      if (!linkEl) return;

      const payload = {
        name: slide.dataset.hpBannerName || '',
        slot: slide.dataset.hpBannerSlot || '',
        target: slide.dataset.hpBannerTarget || linkEl.getAttribute('href') || '',
        blockId: slide.dataset.hpBannerBlock || '',
        clickedAt: new Date().toISOString(),
        synced: false
      };

      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}

      console.info('[LTT Banner Tracking] Homepage banner clicked:', payload);
      syncBannerToCart(payload, true);

      // Fire GA4 native internal promotion click event (preserves external UTMs)
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_promotion', {
          promotion_id: payload.name,
          promotion_name: payload.name,
          creative_name: payload.target,
          creative_slot: `homepage_slide_${payload.slot}`
        });
      }

      // Fire Shopify Customer Events custom event for Web Pixels
      window.Shopify?.analytics?.publish?.('homepage_banner_click', payload);
    },
    true
  );

  // 2. Ensure cart attributes are synced on destination page load
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (stored) {
      syncBannerToCart(stored, !stored.synced);
    }
  } catch (e) {}

  // 3. Re-assert attributes whenever an item is added to cart in this session
  document.addEventListener('variant:add', () => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      if (stored) {
        syncBannerToCart(stored, true);
      }
    } catch (e) {}
  });
})();

// PDP BULK ORDER PROMPT (quantity >= 40)
(() => {
  const BULK_THRESHOLD = 40;
  const SELECTOR = '.product-info__quantity-selector .quantity-selector__input';

  const update = (input) => {
    const prompt = input.closest('.product-info__block-item')?.querySelector('[data-bulk-order-prompt]');
    if (!prompt) return;
    const qty = parseInt(input.value, 10);
    prompt.hidden = !(qty >= BULK_THRESHOLD);
  };

  ['input', 'change'].forEach((evt) =>
    document.addEventListener(evt, (e) => {
      const input = e.target.closest?.(SELECTOR);
      if (input) update(input);
    })
  );

  const init = () => document.querySelectorAll(SELECTOR).forEach(update);
  init();
  // Re-sync after product-rerender swaps (variant changes)
  document.addEventListener('variant:change', () => setTimeout(init, 0));
})();

// if(fptags) {
//   // header account replace
//   if(userCountry === 'CA' || userCountry === 'US') {
//     let accountAnchor = document.getElementById('Account_Anchor');
//     accountAnchor.href = 'https://shopify.com/5845385314/account';
//     let accountShopify = document.getElementById('account-shopify');
//     if(accountShopify){
//       accountShopify.href = 'https://shopify.com/5845385314/account';
//     }
    
//     let mobileAccountAnchor = document.querySelector('#header-sidebar-menu .panel-footer__account-link')
//     mobileAccountAnchor.href = 'https://shopify.com/5845385314/account';
//   }
// }